import React, { useState } from 'react';
import { episodes } from '../mock';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';

const Episodes = () => {
  const [selectedEpisode, setSelectedEpisode] = useState(null);

  return (
    <section className="episodes-section" id="episodes">
      <div className="container">
        <h2 className="section-title-center">Watch Episodes</h2>
        <p className="section-subtitle-center">
          Check out our latest episodes filled with fun, inspiration, and real talk!
        </p>
        
        <div className="episodes-grid-thumbnails">
          {episodes.map((episode) => (
            <div 
              key={episode.id} 
              className="episode-thumbnail-card"
              onClick={() => setSelectedEpisode(episode)}
            >
              <div className="episode-thumbnail-only">
                <img src={episode.thumbnail} alt={episode.title} />
                <div className="play-overlay">
                  <svg className="play-icon" fill="currentColor" viewBox="0 0 24 24" width="48" height="48">
                    <path d="M8 5v14l11-7z"/>
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <Button 
            className="btn-primary"
            onClick={() => window.open('https://www.youtube.com/@NickAndJJShow', '_blank')}
          >
            View More Episodes
          </Button>
        </div>
      </div>

      <Dialog open={!!selectedEpisode} onOpenChange={() => setSelectedEpisode(null)}>
        <DialogContent className="video-dialog">
          <DialogHeader>
            <DialogTitle>{selectedEpisode?.title}</DialogTitle>
          </DialogHeader>
          <div className="video-container">
            <iframe
              width="100%"
              height="400"
              src={`https://www.youtube.com/embed/${selectedEpisode?.videoId}`}
              title={selectedEpisode?.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default Episodes;